import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "progressbar", "progress", "alert"
  ]

  connect() {
    this.progress = 0;
    setTimeout(() => this.update_progress());
  }

  update_progress() {
    this.progress = this.progress + 1;
    setTimeout(() => {
      this.progressbarTarget.style.width = `${this.progress}%`
      if (this.progress < 100) {
        this.update_progress()
      } else {
        this.progressTarget.style.display = "none"
        this.alertTarget.style.display = "block"
      }
    }, 30);
  }
}